import React from "react";
import { BuilderToolbarMenuView } from "components/builderShell/BuilderToolbarMenuView";
import type { IBuilderToolbarMenuViewSection } from "components/builderShell/types";
import { useWebsiteBuilderToolbarContext } from "../websiteBuilderToolbarContext";

export type IWebsiteBuilderToolbarMenuViewSection = IBuilderToolbarMenuViewSection;

interface IWebsiteBuilderToolbarMenuViewProps {
  title: string;
  noSectionsPadding?: boolean;
  goBackToParentView?: () => void;
  sections: IWebsiteBuilderToolbarMenuViewSection[];
  footer?: React.ReactNode;
}

export function WebsiteBuilderToolbarMenuView(props: IWebsiteBuilderToolbarMenuViewProps) {
  const { handleSetToolbarMenuType } = useWebsiteBuilderToolbarContext();

  return (
    <BuilderToolbarMenuView
      {...props}
      onClose={() => handleSetToolbarMenuType?.("none")}
    />
  );
}
